<template>
  <div class="recap-wrap container">
    <div class="recap_top">
      <titleConfig
        :title="langSet == 'cn' ? '精彩回顾' : 'Highlights'"
        :type="1"
        :center="true"
      ></titleConfig>
    </div>
    <div class="recap-main">
      <div class="recap-swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="item in bannerList"
            :key="item.id"
            :data-id="item.id"
          >
            <img :src="item.thumb" alt />
          </div>
        </div>
      </div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper"; // 注意引入的是Swiper
import "../../../../node_modules/swiper/css/swiper.min.css"; //
import titleConfig from "@/components/title.vue";
import { getHighlightReview } from "@/api/api";
export default {
  components: {
    titleConfig,
  },
  data() {
    return {
      langSet: "",
      bannerList: [],
    };
  },
  mounted() {
    this.langSet = this.$language;
    //26.7.3 精彩回顾 dxm
    this.getHighlightReviewList();
  },
  methods: {
    async getHighlightReviewList() {
      const res = await getHighlightReview();
      this.bannerList = res.data.lists;
      let that = this;
      setTimeout(() => {
        this.mySwiper = new Swiper(".recap-swiper", {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: true,
          autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          speed: 3000,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          breakpoints: {
            // 当屏幕宽度 >= 390px 时，显示1个
            // 当屏幕宽度 >= 768px 时，显示3个
            768: {
              slidesPerView: 3,
            },
            // 当屏幕宽度 >= 1024px 时，显示4个
            1024: {
              slidesPerView: 5,
            },
          },
          on: {
            tap: function (swiper, event) {
              const realIndex = mySwiper.realIndex;
              const item = that.bannerList[realIndex];
              that.toLink(item);
            },
          },
        });
      }, 300);
    },

    toMore() {
      this.$router.push({
        path: "/news",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.recap-wrap {
  margin-top: 120px;
  .recap_top {
    margin-bottom: 38px;
  }
  .recap-main {
    padding: 0 68px;
    position: relative;
  }
  .recap-swiper {
    overflow: hidden;
    .swiper-wrapper {
      // display: flex;
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: flex;
      flex-wrap: nowrap;
      transition-property: transform;
      box-sizing: content-box;
      transition-timing-function: linear !important;
    }
    .swiper-slide {
      width: 210px;
      height: 145px;
      border-radius: 20px;
      overflow: hidden;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.swiper-button-next,
.swiper-button-prev {
  color: #42494f;
}
.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 30px;
  font-weight: bold;
}
@media only screen and (max-width: 1280px) {
}
@media only screen and (max-width: 767px) {
  .recap-wrap {
    margin-top: 1.15rem;
    position: relative;
    padding-bottom: 1rem;
    .recap_top {
      margin-bottom: 0.38rem;
    }
  }
}
</style>